/**
 * enum for setting block direction, used by setDirection API
 */
export enum CompatibleDirection {

    /**
     * Left to right
     */
    LeftToRight,

    /**
     * Right to left
     */
    RightToLeft,
}
